import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { useReservationCart } from './ReservationCartContext';

const ReservationCartButton = () => {
  const cart = useReservationCart();
  if (cart.totalQty === 0 || cart.isCheckoutOpen) return null;

  return (
    <button
      type="button"
      onClick={cart.openCheckout}
      data-testid="floating-cart-btn"
      className="fixed bottom-6 right-6 z-40 group flex items-center gap-2 bg-gradient-to-r from-pink-500 via-orange-500 to-amber-500 hover:from-pink-600 hover:via-orange-600 hover:to-amber-600 text-white font-black pl-4 pr-5 py-3 rounded-full shadow-2xl shadow-pink-500/40 transition-all hover:scale-105 animate-fadeIn"
      aria-label={`View reservation cart, ${cart.totalQty} bottle${cart.totalQty !== 1 ? 's' : ''}`}
    >
      <div className="relative">
        <ShoppingBag className="w-5 h-5" />
        <span className="absolute -top-2 -right-2 bg-white text-pink-600 text-[10px] font-black w-4 h-4 rounded-full flex items-center justify-center tabular-nums">
          {cart.totalQty > 9 ? '9+' : cart.totalQty}
        </span>
      </div>
      <span className="hidden sm:inline text-sm">Reserve ({cart.totalQty})</span>
      <span className="sm:hidden text-sm">{cart.totalQty}</span>
    </button>
  );
};

export default ReservationCartButton;
